import { render, staticRenderFns } from "./QuizEpilogueCard.vue?vue&type=template&id=054ec674&scoped=true"
import script from "./QuizEpilogueCard.vue?vue&type=script&lang=js"
export * from "./QuizEpilogueCard.vue?vue&type=script&lang=js"
import style0 from "./QuizEpilogueCard.vue?vue&type=style&index=0&id=054ec674&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ec674",
  null
  
)

export default component.exports